/* unplugin-vue-components disabled */import { render } from "./DeviceConfig.vue?vue&type=template&id=4c9c0a90&scoped=true"
import script from "./DeviceConfig.vue?vue&type=script&lang=js"
export * from "./DeviceConfig.vue?vue&type=script&lang=js"

import "./DeviceConfig.vue?vue&type=style&index=0&id=4c9c0a90&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9c0a90"]])

export default __exports__